<div class="modal-container modal-md text-button">
    <div class="modal-close-container">
        <bizz-icon class="ml-auto block h-5 w-5 text-button md:ml-0"
                   (click)="close()"
                   iconName="xmark" [hover]="true">
        </bizz-icon>
    </div>

    <div class="modal-body !min-h-0 w-full gap-4 overflow-auto">
        <div class="modal-header justify-center font-title">
            <h1>
                {{ data.PopUpModelText | translate }}
            </h1>
        </div>

        <hr>

        <div class="flex flex-col">
            <div class="mt-6 flex w-full items-center gap-4 rounded bg-yellow-500/20 p-4 text-button">
                <bizz-icon iconName="circle-exclamation" class="size-8 text-yellow-500"></bizz-icon>
                {{ data.PopupModelMessage | translate }}
                @if (data.UsageMeterType){
                    @if (data.UsageMeterType === UsageMeterType.AI){
                        AI
                    } @else {
                        BizzMineCredits
                    }
                    <br>{{'ContactAdministrator' | translate }}
                }
            </div>
        </div>
    </div>
    <div class="modal-buttons">
        @if (data.PopUpModalType !== PopUpModalType.AiContentFiltering && data.PopUpModalType !== PopUpModalType.UsageCreditsExceeded){
            <div class="flex flex-row justify-end gap-3 text-center">
                <button class="default" (click)="close()">
                    {{ "Cancel" | translate }}
                </button>
            </div>
        }

        <bizz-loader-button [buttonClass]="'save'" (click)="confirm()" [isLoading]="isLoading">
            <p>{{ "Confirm" | translate }}</p>
        </bizz-loader-button>
    </div>
</div>